import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Input,
  Tooltip,
  Tag,
  Modal,
} from "antd";
import React, { useState, useContext, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import { useNavigate } from "react-router";
import ShowTotal from "../../components/ShowTotal";
import apiPath from "../../constants/apiPath";
import ConfirmationBox from "../../components/ConfirmationBox";
import lang from "../../helper/lang";
import { AuthContext } from "../../context/AuthContext";
import { USERTYPE } from "../../constants/conts";
import TemplateEditor from "../../components/TemplateEditor";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import confirm from "antd/lib/modal/confirm";
const Search = Input.Search;

function Index() {
  const sectionName = lang("Email_Template");

  const [searchText, setSearchText] = useState("");
  const { userProfile, userPermission } = useContext(AuthContext);
  const [templateModal, setTemplateModal] = useState(false);
  const [template, setTemplate] = useState();
  const { request } = useRequest();
  const { showConfirm } = ConfirmationBox();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);
  const navigate = useNavigate();

  const columns = [
    {
      title: `Key`,
      dataIndex: "key",
      key: "title",
    },
    {
      title: `Subject`,
      dataIndex: "subject",
      key: "subject",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, { isActive, _id }) => {
        let color =
          isActive === true
            ? "green"
            : isActive === "suspended"
              ? "yellow"
              : "red";
        return (
          <a>
            <Tag
              onClick={() => confirmStatus(_id, isActive)}
              color={color}
              key={isActive}
            >
              {isActive ? "Active" : "Inactive"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: `${lang("Action")}`,
       
      render: (_, record) => {
        return (
          <>
            <Tooltip title={`Edit Template `} color={"purple"}>
              <Button
                onClick={(e) => {
                  setTemplateModal(true);
                  setTemplate(record);
                }}
              >
                <i className="fa fa-solid fa-edit"></i>
              </Button>
            </Tooltip>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText]);

  const fetchData = (pagination) => {
    const params = new URLSearchParams();
    params.append("page", pagination?.current);
    params.append("limit", pagination?.pageSize);
    request({
      url: `${apiPath.listEmailTemplate}?${params.toString()}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.data);
        setPagination((prev) => ({
          current: pagination?.current,
          total: data.data.total,
          pageSize: Number(data.data?.limit),
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    console.log(pagination, filters);
    fetchData(pagination, filters);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };

  const confirmStatus = (id, status) => {
    setTimeout(() => {
      confirm({
        maskClosable: true,
        icon: <ExclamationCircleOutlined />,
        className: "tab_modal",
        cancelButtonProps: { color: "red" },
        content: (
          <p
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Are you sure you want change the status ?
          </p>
        ),
        onOk() {
          request({
            url: `${apiPath.updateEmailStatus}/${id}`,
            method: "PUT",
            data: {},
            onSuccess: (data) => {
              fetchData(pagination);
              ShowToast(
                data.message || "Status Changed Successfully",
                Severty.SUCCESS,
              );
            },
            onError: (error) => {
              setLoading(false);
              ShowToast(error, Severty.ERROR);
            },
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + ` ${lang("Manager")}`}
            >
              <h4 className="text-right mb-1">
                {pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}
              </h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Template Modal */}
      <Modal
        open={templateModal}
        footer={null}
        width={900}
        centered
        closable
        onCancel={() => setTemplateModal(false)}
      >
        <TemplateEditor
          template={template}
          onUpdate={fetchData}
          setTemplateModal={setTemplateModal}
        />
      </Modal>
    </>
  );
}

export default Index;
